import BlogCategory from ".";


export const blogCategoryRoutes = () => [
  {
    path: "/admin/blog-categories",
    component: BlogCategory,
    layout: "admin",
    routeType: "admin",
    title: "Blogs Management",
  },
];
